import { type Accept } from 'react-dropzone';
import { t } from '../../i18n';
import { type FileUploadInputValidator } from './types';

export const CSV_ACCEPT: Accept = {
  'text/csv': ['.csv'],
  'text/plain': ['.csv'],
  'application/vnd.ms-excel': ['.csv'],
};

export const formatFileSize = (sizeInBytes: number): string => {
  if (sizeInBytes < 1024) {
    return `${sizeInBytes}B`;
  }

  const units = ['KB', 'MB', 'GB', 'TB'];
  let size = sizeInBytes;
  let unitIndex = -1;

  while (size >= 1024 && unitIndex < units.length - 1) {
    size /= 1024;
    unitIndex += 1;
  }

  const formattedSize = Number.isInteger(size) ? size.toString() : size.toFixed(1);
  return `${formattedSize}${units[unitIndex]}`;
};

export const csvFileValidator: FileUploadInputValidator = file => {
  if (file.name.toLowerCase().endsWith('.csv')) {
    return null;
  }

  return {
    code: 'file-invalid-type',
    message: t('common:csvFileValidator.error'),
  };
};
